const Terms = () => {
  return (
    <div style={{ width: '90%', maxWidth: 725, margin: 'auto' }}>
      <p>Consignment Agreement</p>
      <p>
        This Consignment Agreement (the “Agreement”) states the terms and
        conditions that govern the contractual agreement between (YOU) (the
        “Consignor”) and Reef Labs LLC, located at (the “Consignee”) who agree
        to be bound by this Agreement.
      </p>
      <p>
        WHEREAS, the Consignor owns right and title to the items described on
        Exhibit A attached hereto (the “Consigned Items”), and the Consignee
        desires to take possession of the Consigned Items with the intention of
        renting it to a third party.
      </p>
      <p>
        NOW, THEREFORE, in consideration of the mutual covenants and promises
        made by the parties hereto, the Consignor and the Consignee
        (individually, each a “Party” and collectively, the “Parties”) covenant
        and agree as follows:
      </p>
      <p>
        RIGHT TO RENT. The Consignor hereby grants to the Consignee the
        exclusive right to display and rent the Consigned Items according to the
        terms and conditions of this Agreement.
      </p>
      <p>
        CONSIGNMENT FEE. The Consignee shall be entitled to 70% of the full
        purchase price of the Consigned Items (the “Consignment Fee”) over the
        period of the term of the rental (Monthly or Weekly).
      </p>
      <p>
        Within 5 of days from the sale of the Consigned Items, the Consignee
        shall deliver to the Consignor the rental price of the Consigned Items
        less the Consignment Fee.
      </p>
      <p>
        By renting through our platform, We reserves the right to deduct 30% of
        the rental sale if the rental has to be refunded. By renting through our
        system, you will provide a rental for the full length. If you request a
        refund for the following reasons, then the 30% deduction from your
        account will occur. The reasons are, but not limited to, requesting that
        the rental is ended early, that the rental key was incorrect, the rental
        length is incorrect, the key is non-functional, the buyer did not
        receive proper support, listing an incorrect software, as well as many
        other situations we are allowed to determine on a case to case basis. If
        your seller account does not have enough credits for the 30% deduction,
        then we will automatically withdraw the amount from your bank account
        that is linked.
      </p>
      <p>
        INSURANCE. The Consignor understands and agrees that the Consignee (BOT
        MART LLC) is not personally or legally liable for any actions taken on
        behalf of a third party which may interfere with the digital goods or
        cause the goods to be destroyed or suspended. Additionally, consignor
        (YOU) understand all the risks involved with renting out digital goods,
        and that any loss will not be covered by the company.
      </p>
      <p>
        LOCATION OF ITEMS. The Consignee agrees and acknowledges that the
        Consigned Items shall only be kept and stored safely in the hands of the
        rental team unless otherwise the product is rented which in turn will be
        delivered to a third party.
      </p>
      <p>
        TIMEFRAME. In the event that all the Consigned Items are not rented
        within 1 week of the agreement, the consignor may retake items.
      </p>
      <p>
        CONSIGNOR REPRESENTATION. The Consignor hereby represents and warrants
        that the Consignor holds full title (or has received, in writing, the
        authorization to sell the Consigned Items by any necessary parties) to
        the Consigned Items.
      </p>
      <p>
        EXPENSES. The Consignee shall bear all expenses for the consigned items,
        outside of losses/damages caused by third parties.
      </p>
      <p>
        NO MODIFICATION UNLESS IN WRITING. No modification of this Agreement
        shall be valid unless in writing and agreed upon by both Parties.
      </p>
      <p>
        APPLICABLE LAW. This Agreement and the interpretation of its terms shall
        be governed by and construed in accordance with the laws of the State of
        New Hampshire and subject to the exclusive jurisdiction of the federal
        and state courts located in New Hampshire.
      </p>
      <p>
        IN WITNESS WHEREOF, by accepting the terms and using our service, the
        consignor consents and agrees to all terms stated here, on the website
        (https://rentals.botmrt.com)and in the Bot Mart discord server
        (discord.gg/botmart)
      </p>
      <p> </p>
      <p> </p>
    </div>
  );
};

export default Terms;
